import { useState } from 'react';
import { commentPicks } from '@/mocks/homeData';
import SectionHead from './SectionHead';

const sideStyle: Record<string, string> = {
  支持: 'bg-primary-100 text-primary-700',
  质疑: 'bg-secondary-100 text-secondary-900',
  中立: 'bg-accent-100 text-accent-900',
};

export default function CommentPicks() {
  const [liked, setLiked] = useState<Record<string, boolean>>({});

  const toggleLike = (id: string) => {
    setLiked((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <section id="comments" className="w-full border-b border-background-200 bg-background-100">
      <div className="mx-auto max-w-[1440px] px-4 py-10 md:px-8 md:py-14">
        <SectionHead
          zone="分区 04"
          title="围观群众精选"
          desc="从公开讨论中挑出信息量较高的评论，三种态度并列，方便对照着看。"
          extra={
            <a
              href="#subscribe"
              className="flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-foreground-300 px-4 py-2 font-label text-xs font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600"
            >
              <i className="ri-add-circle-line text-sm" aria-hidden="true"></i>
              我要发言
            </a>
          }
        />

        <div className="mt-7 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          {commentPicks.map((c, idx) => (
            <article
              key={c.id}
              style={{ animationDelay: `${idx * 60}ms` }}
              className="animate-rise-in flex flex-col rounded-lg border border-background-200 bg-background-50 p-4 md:p-5"
            >
              <div className="flex items-center gap-3">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-secondary-500 font-heading text-base font-black text-background-50">
                  {c.avatarText}
                </span>
                <div className="min-w-0 flex-1">
                  <p className="truncate font-heading text-sm font-bold text-foreground-900">{c.user}</p>
                  <p className="font-label text-[11px] text-foreground-400">讨论：{c.topic}</p>
                </div>
                <span className={`shrink-0 rounded-sm px-2 py-0.5 font-label text-[11px] font-medium ${sideStyle[c.side]}`}>
                  {c.side}
                </span>
              </div>

              <p className="mt-4 flex-1 font-body text-sm leading-relaxed text-foreground-700">{c.content}</p>

              <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3">
                <button
                  type="button"
                  onClick={() => toggleLike(c.id)}
                  className={`flex cursor-pointer items-center gap-1.5 font-label text-xs transition-colors ${
                    liked[c.id] ? 'text-primary-600' : 'text-foreground-500 hover:text-primary-600'
                  }`}
                >
                  <i className={liked[c.id] ? 'ri-thumb-up-fill text-sm' : 'ri-thumb-up-line text-sm'} aria-hidden="true"></i>
                  {c.likes + (liked[c.id] ? 1 : 0)}
                </button>
                <span className="flex cursor-pointer items-center gap-1.5 font-label text-xs text-foreground-500 hover:text-primary-600">
                  <i className="ri-chat-3-line text-sm" aria-hidden="true"></i>
                  回复
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}